module.exports = __webpack_public_path__ + "root-2bf1921b/og-xing-logo-47744aa374db46e83e91131f3a8a0db5.png";